
function Loader(props) {
  return (
    <div id={props.load ? "preloader-wrapper" : "preloader-none"}>
      <div id="preloader"></div>
    </div>
  );
}

export default Loader;
